import React, { useState, useEffect } from 'react';

const About = () => {
  // Image arrays for each feature carousel
  const globalReachImages = [
    '/images/about/global-reach-1.jpg',
    '/images/about/global-reach-2.jpg',
    '/images/about/global-reach-3.jpg'
  ];

  const expertiseImages = [
    '/images/about/expertise-1.jpg',
    '/images/about/expertise-2.jpg',
    '/images/about/expertise-3.jpg'
  ];

  const solutionsImages = [
    '/images/about/solutions-1.jpg',
    '/images/about/solutions-2.jpg',
    '/images/about/solutions-3.jpg'
  ];

  // Carousel component
  const ImageCarousel = ({ images, interval = 3000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
      const timer = setInterval(() => {
        setCurrentIndex((prevIndex) => 
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
      }, interval);

      return () => clearInterval(timer);
    }, [images.length, interval]);

    const goToSlide = (index) => {
      setCurrentIndex(index);
    };

    return (
      <div className="carousel-container">
        <div className="carousel-slide">
          <img 
            src={images[currentIndex]} 
            alt={`Feature ${currentIndex + 1}`}
            className="carousel-image"
          />
        </div>
        <div className="carousel-indicators">
          {images.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    );
  };

  return (
    <section id="about" className="about-section">
      <div className="about-background">
        {/* Background image will be applied via CSS */}
      </div>
      <div className="container">
        <div className="about-header">
          <img src="logo.png" alt="OxyCom Logo" className="about-logo" />          
          <h2>ADVANCING GLOBAL COMMODITY TRADING, TOGETHER</h2>
        </div>
        
        <div className="about-content-grid">
          <div className="about-main-content">
            <div className="about-text-content">
              <p className="lead-paragraph">
                Oxycom is a dynamic and established international trading and procurement 
                company dedicated to delivering comprehensive supply chain solutions for 
                enhanced efficiency and value, every step of the way from source to market.
              </p>
              
              <div className="about-details">
                <p>
                  The Oxycom Group of companies has a proven track record spanning several years 
                  in the import and export industry. Headquartered in Mauritius, with a strong 
                  operational presence across Southern Africa including Zimbabwe, Malawi, Zambia, 
                  and South Africa, Oxycom serves as a trusted partner to businesses across 
                  multiple sectors.
                </p>
                
                <p>
                  From strategic commodity trading and procurement to innovative supply chain 
                  financing and risk management solutions, you can count on us for a full suite 
                  of services that help optimize your operations and extend your market reach 
                  across global commodity markets.
                </p>
              </div>
            </div>
          </div>
          
          <div className="about-highlights">
            <div className="highlight-item">
              <div className="highlight-number">5+</div>
              <div className="highlight-text">Countries</div>
            </div>
            <div className="highlight-item">
              <div className="highlight-number">10+</div>
              <div className="highlight-text">Years Experience</div>
            </div>
            <div className="highlight-item">
              <div className="highlight-number">100+</div>
              <div className="highlight-text">Clients Served</div>
            </div>
            <div className="highlight-item">
              <div className="highlight-number">Global</div>
              <div className="highlight-text">Supply Network</div>
            </div>
          </div>
        </div>
        
        <div className="about-features">
          <div className="feature-item">
            <div className="feature-carousel">
              <ImageCarousel images={globalReachImages} interval={4000} />
            </div>
            <h3>Global Reach</h3>
            <p>Strategic presence across Southern Africa with international trading partnerships</p>
          </div>
          <div className="feature-item">
            <div className="feature-carousel">
              <ImageCarousel images={expertiseImages} interval={3500} />
            </div>
            <h3>Proven Expertise</h3>
            <p>Years of experience in commodity trading and international procurement</p>
          </div>
          <div className="feature-item">
            <div className="feature-carousel">
              <ImageCarousel images={solutionsImages} interval={4500} />
            </div>
            <h3>Integrated Solutions</h3>
            <p>End-to-end supply chain management and financial solutions</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;